export const initialLoginError = { email: null, password: null, common: null };
export const initialRegisterError = { email: null, password: null, name: null, common: null };
